export default __webpack_public_path__ + "static/article-how-to-stay-safe-when-shopping-online-5a35f329c2af010b5d687e29bf8ac671.jpg";